import { Injectable } from '@angular/core';

import { statusPretendidoNaoPretendido, statusPretendidoPretendido, statusPretendidoPotencial, statusPretendidoRealizado } from '../cliente-analise-mercado-status-pretendido';

@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseMercadoStatusPretendidoService {
    /** Retorna o status pretendido da análise de mercado de clientes */
    getStatusPretendido(
        // Potencial
        quantidadePotencial: number,
        pesoPotencial: number,
        valorPotencial: number,
        // Pretendido/Projetado
        quantidadePretendidaProjetada: number,
        pesoPretendidoProjetado: number,
        valorPretendidoProjetado: number,
        // Realizado
        quantidadeRealizada: number,
        pesorealizado: number,
        valorRealizado: number
    ): number {
        // Pretendido => Se possuir quantidade ou peso ou valor pretendido
        if (quantidadePretendidaProjetada > 0 || pesoPretendidoProjetado > 0 || valorPretendidoProjetado > 0) {
            return statusPretendidoPretendido.id;
        }

        // Potencial => Se possuir somente a quantidade ou peso ou valor potencial
        if (quantidadePotencial > 0 || pesoPotencial > 0 || valorPotencial > 0) {
            return statusPretendidoPotencial.id;
        }

        // Realizado => Se possuir somente a quantidade ou peso ou valor realizado
        if (quantidadeRealizada > 0 || pesorealizado > 0 || valorRealizado > 0) {
            return statusPretendidoRealizado.id;
        }

        // Não Pretendido =>  Se não possuir nem potencial, nem pretendido e nem realizado
        return statusPretendidoNaoPretendido.id;
    }
}
